/**
* Website for creating outer Campusnet Polygon
* */
import L from 'leaflet';
import {useEffect, useRef} from "react";
import 'leaflet-draw';
import drawLocales from 'leaflet-draw-locales';
import './OutdoorPlanningMap.css';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { Toast } from 'primereact/toast';



const OutdoorPlaningMap = ({setArea,setPolygon})=> {
    let toast = useRef();
    // called after the render function to alter the webpage
    useEffect(() => {
        let current_lat = 51.49209763499161;
        let current_long = 7.4116882914122;
        let current_zoom = 16;
        let center_lat = current_lat;
        let center_long = current_long;
        let center_zoom = current_zoom;
        let draw_Start  = false;
        // The <div id="map"> must be added to the dom before calling L.map('map')
        let map = L.map('map', {
            center: [center_lat, center_long],
            zoom: center_zoom,
        });
        map.doubleClickZoom.disable();
        L.tileLayer( 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            minZoom: 6,
            maxNativeZoom: 18,
            maxZoom: 20,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(map);
        /**
         * Begin drawing cursor
         */
        var cursor = L.circle([0,0], {radius: 0,color:"#6c757d"});
        var cursorTT = L.tooltip();
        cursorTT.setContent("Klicken, um mit Skizze zu beginnen.");
        cursor.bindTooltip(cursorTT,{'className':'cursor-tooltip','permanent':'true'});
        cursor.addTo(map);
        /**
         * Drawing layer
         */
        var drawnItems = new L.FeatureGroup();
        map.addLayer(drawnItems);
        var drawControl = new L.Control.Draw({
            draw:false,
            edit: {
                edit: false,
                featureGroup: drawnItems,
            },
            tooltip:{'className': 'polygon-tooltip'},
        });
        L.EditToolbar.Delete.include({
            enable: function () {
                this.options.featureGroup.clearLayers()
                const next = document.getElementById('next')
                next.classList.remove('hover');
                next.classList.add('fa-disabled');
                next.style.pointerEvents="none";
                map.on("click", function (e) { onMapClick(e)});
                cursor.bindTooltip(cursorTT,{'className':'cursor-tooltip','permanent':'true'});
                cursor.addTo(map);
                localStorage.clear();
            }
        })
        map.addControl(drawControl)
        /**
         * on*-Handlers
         */
        map.on("click", function (e) { onMapClick(e)});
        map.on(L.Draw.Event.DRAWSTART,function () {draw_Start=true; map.removeLayer(cursor)});
        map.on(L.Draw.Event.CREATED,function (e) { onDrawCreated(e)});
        map.on("mousemove", function (e) {
            cursor.setLatLng(e.latlng);
        });
        L.Draw.Polyline.prototype._onTouch = L.Util.falseFn;
        // do nothing on focus
        map.getContainer().focus = ()=>{}
        /**
         * Automatically defines Leaflet.draw to the specified language
         */
        drawLocales('de')
        const locale = drawLocales('de')
        locale.draw.handlers.polygon.tooltip.end = 'Ersten Punkt anklicken oder Doppelklicken, um die Form abzuschließen.'
        L.drawLocal = locale
        /**
         * New Polygon Object which is added to Map with additional options
         * @type {Draw.Polygon}
         */
        var drawPolygon = new L.Draw.Polygon(map,
            {
                shapeOptions: {
                    color: "#6c757d",
                    fill:true
                }
            });
        /**
         * Search Controller with OSM Provider
         */
        const provider = new OpenStreetMapProvider();
        new GeoSearchControl({
            provider: provider, // required
            showMarker: false,
            position: "topleft",
            style: 'bar', // optional: bar|button  - default button
            searchLabel: 'Adresse eingeben...',
        }).addTo(map);
        /**
         * Handler functions
         */
        /**
         * Start drawing when clicking on the Map
         */
        function onMapClick(e){
            if(draw_Start === false || !drawnItems.getLayers().length){
                map.on('dblclick',function (){drawPolygon.completeShape()})
                drawPolygon.enable();
                drawPolygon.addVertex(e.latlng);
            }
        }
        /**
         * Save Polygon, add to map, calculate Area
         */
        function onDrawCreated(e) {
            localStorage.setItem("calc",true);
            map.removeEventListener("dblclick");
            //document.getElementById('reset_polygon').disabled = true;
            var type = e.layerType;
            var layer = e.layer;
            //cursorTT.setContent("&#128465; Gebiet zurücksetzen, um eine neue Skizze zu beginnen.");
            cursor.openTooltip();
            if (type === 'polygon') {
                var area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
                var output;
                var output_num;
                setPolygon(layer);
                output_num = Math.round((area / 1000000) * 100000) / 100000;
                if (output_num >= 10) {
                    toast.current.show({life: 5000, severity: 'error', summary: 'Fehler', detail: 'Das ausgewählte Gebiet darf 10 km² nicht überschreiten.'});
                    return;
                }
                drawnItems.addLayer(layer);
                output = String(output_num).replace('.', ',') + " km<sup>2</sup>";
                layer.bindTooltip(output, {
                    permanent: true,
                    className: 'polygon-tooltip'
                });
            }
            const next = document.getElementById('next')
            next.classList.add('hover');
            next.classList.remove('fa-disabled');
            next.style.pointerEvents="auto";
            setArea(output_num);
            // coords = layer._latlngs[0];
            // coords = convertCoordinatesArray(coords);
            // var coordsStr = coords.join(',');
            // areaRequest(coordsStr, output_num);
        }

        if (localStorage.getItem("polygon") != null)
        {
            map.removeEventListener("click");
            map.removeLayer(cursor)
            let poly = L.polygon(JSON.parse(localStorage.getItem("polygon")),{color: '#6c757d',fill:true}).addTo(drawnItems)
            var area = L.GeometryUtil.geodesicArea(poly.getLatLngs()[0]);
            var output;
            var output_num;
            output_num = Math.round((area / 1000000) * 100000) / 100000;
            output = String(output_num).replace('.', ',') + " km<sup>2</sup>";
            poly.bindTooltip(output, {
                directon: "center",
                permanent: true,
                className: 'polygon-tooltip'
            });
            map.fitBounds(poly.getBounds())
            const next = document.getElementById('next')
            next.classList.add('hover');
            next.classList.remove('fa-disabled');
            next.style.pointerEvents = "auto";
            setArea(output_num)
        }
    });
    return (
        <div >
            <div id="map"/>
            <div className={'text-center'} style={{pointerEvents:"none", marginTop:'-140px',position:'relative',zIndex:'1'}}>
                <div className={'my-5 px-3 py-1 d-inline-block bg-secondary text-white rounded-3'} style={{pointerEvents:"auto"}}>
                    <div className='fs-4'>Bitte wählen Sie Ihr Campusnetzgebiet mit einfachen Klicken aus</div>
                </div>
            </div>
            <Toast ref={toast} />
        </div>
    );
};

export default OutdoorPlaningMap;
